<template>
  <div class="sp_layout">
    <el-container class="sp_container">
      <el-aside width="auto"
                class="sp_aside">
        <div v-if="!isCollapse"
             class="sp_logo"
             :class="{logoActive:isCollapse == true}">
          <svg-icon class="logo logo-img"
                    icon-class="logo-1"></svg-icon>
          <svg-icon v-show="!isCollapse"
                    class="logo logo-label"
                    icon-class="logo-2"></svg-icon>
        </div>
        <div class="pack-up-sp-logo"
             v-if="isCollapse">
          <svg-icon class="pack-up-logo"
                    icon-class="logo-1"></svg-icon>
        </div>
        <el-menu :default-active="defaultActive"
                 class="el-menu-vertical-demo"
                 router
                 background-color="#051425"
                 text-color="#aab0b8"
                 active-text-color="#FFFFFF"
                 :collapse="isCollapse"
                 collapse-transition
                 :class="{isActive_nav:!isCollapse,pack_up:isCollapse}"
                 :unique-opened="true">
          <el-menu-item class="father-item"
                        :index="navMenu[0].path"
                        :router="'/layout/'+navMenu[0].path"
                        @click.native="handleSelect(navMenu[0])">
            <!-- <i class="el-icon-s-home"></i> -->
            <svg-icon icon-class="asidehome"
                      style="padding:0 0 0 5px; font-size:16px; margin-right:10px;"></svg-icon>
            <span slot="title">{{navMenu[0].name}}</span>
          </el-menu-item>

          <el-submenu class="sub-item"
                      :index="val.id"
                      v-for="val in navMenuList"
                      :key="val.id"
                      v-bottom>
            <template v-if="val.children.length>0"
                      slot="title">
              <svg-icon style="padding:0 0 0 5px; font-size:16px; margin-right:10px;"
                        :icon-class="val.icon"></svg-icon>
              <span>{{val.name}}</span>
            </template>
            <el-menu-item-group v-for="item in val.children"
                                :key="item.id">
              <el-menu-item :index="item.path"
                            :router="'/layout/'+item.path"
                            @click.native="handleSelect(item)">
                <span slot="title">{{item.name}}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item class="father-item"
                        :index="navMenu[navMenu.length - 1].path"
                        :router="'/layout/'+navMenu[navMenu.length - 1].path"
                        @click.native="handleSelect(navMenu[navMenu.length - 1])">
            <svg-icon style="margin-left:1px"
                      class="el-icon-s-home"
                      :icon-class="navMenu[navMenu.length - 1].icon"></svg-icon>
            <span slot="title">{{navMenu[navMenu.length - 1].name}}</span>
          </el-menu-item>

        </el-menu>
        <div class="sp_slide"
             @click="slideAside">
          <svg-icon icon-class="fold"></svg-icon>
        </div>
      </el-aside>
      <el-container>
        <el-header class="sp_header"
                   height="44px">
          <el-row>
            <el-col :span="18">
              <nav-menu :tabsDataMsg="tabsData"
                        :activeMsg="activeIndex"
                        @tabCloseMsg="tabCloseMsg"
                        @tabActiveMsg="tabActiveMsg"></nav-menu>
            </el-col>
            <el-col :span="6">
              <user-info @personalCenterHandler="personalCenterHandler"
                         :tabsData="tabsData"></user-info>
            </el-col>
          </el-row>
        </el-header>
        <el-main class="sp_main">
          <keep-alive :include="keepComponent">
            <router-view />
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import navMenu from '../../components/navMenu.vue';
import UserInfo from '../../components/userInfo.vue';
import { mapGetters } from "vuex"
export default {
  components: { navMenu, UserInfo },
  name: 'layout',
  data () {
    return {
      isCollapse: false,
      defaultActive: 'home',//菜单默认激活
      keepComponent: [],
      navMenuList: [],
      tabsData: [],
      activeIndex: 0,//tabs默认激活
    }
  },
  computed: {
    ...mapGetters(['navMenu']),
  },

  directives: {
    bottom: {
      // bind (el) {
      //   let icon = el.getElementsByClassName('el-submenu__icon-arrow el-icon-arrow-down')[0];
      //   icon.className = 'el-submenu__icon-arrow el-icon-caret-right';
      //   icon.style.fontSize = '15px';
      // }
    }
  },

  methods: {
    //展开收起
    slideAside () {
      this.isCollapse = !this.isCollapse;
    },
    personalCenterHandler () {
      const isOpenPersonalCenter = this.tabsData.find(item => {
        return item.path === 'personalCenter'
      })
      const val = {
        children: [],
        component: "/personalCenter/index",
        id: "",
        name: "Personal Center",
        parentId: "0",
        path: 'personalCenter',
      }
      if (!isOpenPersonalCenter) {
        this.tabsData.push(val)
        this.handleSelect(val)
        this.$router.push({ path: 'personalCenter' })
      } else {
        const index = this.tabsData.findIndex(item => {
          return item.path === val.path
        })
        const data = {
          index: index,
          val: val
        }
        this.$router.push({ path: 'personalCenter' })
        this.tabActiveMsg(data)
        location.reload()
        this.activeIndex = index

      }



    },
    //添加标签页
    handleSelect (val) {
      this.defaultActive = val.path
      if (this.tabsData.length > 0) {
        var result = this.tabsData.some(item => {
          if (item.name == val.name) {
            return true
          }
        })

        if (!result) {
          this.tabsData.push(val)
          this.keepComponent.push(val.path)
        }
      } else {
        this.tabsData.push(val)
        this.keepComponent.push(val.path)
      }

      for (var i = 0; i < this.tabsData.length; i++) {
        if (this.tabsData[i].path == val.path) {
          this.activeIndex = i;
        }
      }
      //这里存一个页面打开历史记录，刷新页面之后让状态继续保持
      var defaultObj = {
        defaultActive: this.defaultActive,
        activeIndex: this.activeIndex,
        tabsData: this.tabsData
      }
      this.$ls.set("defaultObj", defaultObj)
    },

    //关闭标签页
    tabCloseMsg (data) {
      // console.log(data,this.defaultActive);
      this.tabsData.forEach((val, index) => {
        if (val.path == data.path) {
          this.tabsData.splice(index, 1)
          this.keepComponent.splice(index, 1)
          //关闭页面后判断一下关闭之后还剩几个页面，剩多个就打开关闭页面的后一个页面，否则就打开home页面
          if (this.tabsData.length > 1) {
            //这里判断一波关闭的是不是当前激活的页面
            if (data.path == this.defaultActive) {
              if (index == this.tabsData.length) {
                this.$router.push({ path: '/layout/' + this.tabsData[index - 1].path })
                this.defaultActive = this.tabsData[index - 1].path
                this.activeIndex = index - 1;
              } else {
                console.log(index);
                console.log(this.tabsData);
                this.$router.push({ path: '/layout/' + this.tabsData[index].path })
                this.defaultActive = this.tabsData[index].path
                this.activeIndex = index;
              }
            } else {
              this.tabsData.forEach((val, index) => {
                if (val.path == this.defaultActive) {
                  this.activeIndex = index;
                }
              })
            }
          } else {
            this.$router.push({ path: '/layout/' + this.tabsData[0].path })
            this.defaultActive = this.tabsData[0].path
            this.activeIndex = 0;
          }
        }
      })

      var defaultObj = {
        defaultActive: this.defaultActive,
        activeIndex: this.activeIndex,
        tabsData: this.tabsData
      }
      this.$ls.set("defaultObj", defaultObj)
      if (data.path === 'myAssetsList') {
        this.$store.commit('LOAD_ASSETS_PAGE', true)
      }

      if (data.path === 'allCase') {
        this.$store.commit('LOAD_CASE_PAGE', true)
      }
    },

    //激活标签页
    tabActiveMsg (data) {
      this.defaultActive = data.val.path
      var defaultObj = {
        defaultActive: this.defaultActive,
        activeIndex: data.index,
        tabsData: this.tabsData
      }
      this.$ls.set("defaultObj", defaultObj)
    }
  },

  created () {
    //因为home是没有子菜单，这里截出有子菜单的单独处理 深拷贝下数组，防止影响到原数组
    let CopyNav = []
    for (var i = 0; i < this.navMenu.length; i++) {
      CopyNav.push(this.navMenu[i])
    }
    this.navMenuList = CopyNav.slice(1, CopyNav.length - 1)
    let defaultObj = this.$ls.get("defaultObj")
    if (defaultObj) {
      this.defaultActive = defaultObj.defaultActive;
      this.activeIndex = defaultObj.activeIndex;
      this.tabsData = defaultObj.tabsData;
      this.$router.push({ path: '/layout/' + defaultObj.defaultActive })

      for (var i = 0; i < this.tabsData.length; i++) {
        this.keepComponent.push(this.tabsData[i].path)
      }
    } else {
      this.tabsData.push(this.navMenu[0])
    }
  },
}
</script>

<style lang="scss" scoped>
.sp_layout {
  width: 100%;
  height: 100%;
  background: #f0f3f7;
  .sp_container {
    width: 100%;
    height: 100%;
    .sp_aside {
      position: relative;
      .el-menu--collapse {
        width: 56px;
      }
      .el-menu-vertical-demo {
        height: 100%;
        padding: 72px 8px 70px 8px;
        box-sizing: border-box;
        border-right-color: #2d3037;
        .father-item {
          padding: 0 12px 0 7px !important;
          font-size: 14px;
          /deep/.el-tooltip {
            padding: 0 8px !important;
          }
        }
        /deep/.el-submenu__title {
          padding: 0 12px 0 7px !important;
          font-size: 14px !important;
        }
        /deep/.el-submenu .el-menu-item {
          position: relative;
          .svg-icon {
            position: absolute;
            top: 50%;
            left: 20px;
            transform: translateY(-50%);
            font-size: 24px;
          }
          span {
            font-size: 14px !important;
          }
        }
      }
      .isActive_nav {
        /deep/.el-menu-item.is-active {
          background: rgba(38, 132, 255, 1) !important;
          border-radius: 4px !important;
          height: 32px !important;
          line-height: 32px !important;
          margin: 4px 0 !important;
          font-size: 14px !important;
        }
        .pack_up {
          margin: 0 auto;
        }
      }
      .sp_logo {
        display: flex;
        height: 64px;
        z-index: 1024;
        background-color: rgb(5, 20, 37);
        transition: all 0.5s;
        position: absolute;
        top: 12px;
        left: 10px;
        // width: 124px;
        .logo {
          height: 64px;
        }
        .logo-img {
          height: 36px;
          width: 36px;
        }
        .logo-label {
          width: 85px;
          height: 36px;
        }
      }
      .pack-up-sp-logo {
        position: absolute;
        top: 12px;
        left: 10px;
        height: 64px;
        width: 36px;
        z-index: 1024;
        background-color: rgb(5, 20, 37);
        .pack-up-logo {
          height: 36px;
          width: 36px;
        }
      }
      .sp_slide {
        position: absolute;
        bottom: 24px;
        left: 20px;
        .svg-icon {
          font-size: 16px;
          color: #9ba1a7;
          cursor: pointer;
        }
      }
    }
    .sp_header {
      width: 100%;
      background-color: #ffffff;
      border-bottom: 1px solid #e1e6ed;
    }
    .sp_main {
      padding: 16px;
      background: #f0f3f7;
      height: 100%;
    }
  }
}
/deep/.el-menu-item [class^="el-icon-"] {
  width: 24px !important;
  vertical-align: middle !important;
}
</style>